import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Put a new page at the top of itself.
 *
 * React Router keeps the window's scroll offset across a navigation, so moving between two
 * pages of different lengths leaves the visitor part-way down the new one. On a portal that
 * showed up as "press Check Coverage and it jumps to the newsletter": the postcode box sits
 * far down the storefront home page, and carrying that offset onto the shorter coverage page
 * landed the visitor in the footer.
 *
 * Restores the browser's own behaviour in the two cases where scrolling is wanted:
 *   - Back/Forward (POP) keeps the position, as a browser normally would.
 *   - A #hash link is left alone, so in-page anchors still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (hash) return
    if (navigationType === 'POP') return
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash, navigationType])

  return null
}
